export const imageObjConstructor = imageJSON => {
  const { url, ...imageDetails } = (imageJSON && JSON.parse(imageJSON)) || {}
  return {
    src: url,
    ...imageDetails,
  }
}
